import { REQUEST_TYPES, ROLES, ROUTES } from "shared/config";

// TODO store page raoutes in a separate file
export function getRedirectRoute(role, requestType) {
  // * User
  if (
    role === ROLES.USER &&
    (requestType === REQUEST_TYPES.EXPENSE ||
      requestType === REQUEST_TYPES.TRAVEL)
  )
    return ROUTES.request.user_queue;
  if (role === ROLES.USER && requestType === REQUEST_TYPES.EUROCARD)
    return ROUTES.cards.corporate_cards_requests_queue_user;
  if (
    role === ROLES.USER &&
    [REQUEST_TYPES.CREDIT_CARD, REQUEST_TYPES.AMEX_BTA].includes(requestType)
  )
    return ROUTES.cards.card_requests_queue_user;
  // * Supervisor
  if (
    role === ROLES.SUPERVISOR &&
    (requestType === REQUEST_TYPES.EXPENSE ||
      requestType === REQUEST_TYPES.TRAVEL)
  )
    return ROUTES.request.supervisor_queue;
  if (role === ROLES.SUPERVISOR && requestType === REQUEST_TYPES.EUROCARD)
    return ROUTES.cards.corporate_cards_requests_queue_supervisor;
  if (
    role === ROLES.SUPERVISOR &&
    [REQUEST_TYPES.CREDIT_CARD, REQUEST_TYPES.AMEX_BTA].includes(requestType)
  )
    return ROUTES.cards.card_requests_queue_supervisor;
  // * Additional Acceptor
  if (
    role === ROLES.ADDITIONAL_ACCEPTOR &&
    (requestType === REQUEST_TYPES.EXPENSE ||
      requestType === REQUEST_TYPES.TRAVEL)
  )
    return ROUTES.request.additional_acceptor_queue;
  if (
    role === ROLES.ADDITIONAL_ACCEPTOR &&
    [REQUEST_TYPES.CREDIT_CARD, REQUEST_TYPES.AMEX_BTA].includes(requestType)
  )
    return ROUTES.cards.card_requests_queue_additional_acceptor;
  // * Cost Group
  if (role === ROLES.COST_GROUP) return ROUTES.cost_group.queue;
  // * Accounts Payable
  if (role === ROLES.ACCOUNTS_PAYABLE)
    return ROUTES.accounts_payable.queue_common;
  return ROUTES.home;
}
